var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"multi-select",on:{"click":_vm.showPopup}},[(_vm.showValue)?_c('span',{staticClass:"multi-select-textarea"},[_vm._v(_vm._s(_vm.showValue))]):_c('span',{staticClass:"placeholder"},[_vm._v(_vm._s(_vm.gettext('请选择')))])])}
var staticRenderFns = []

export { render, staticRenderFns }